function initPopupCookie() {
    $.ajax({
        type: 'POST',
        url: '/ajax/popup_cookie.php',
        data: '',
        success: function (data) {
            $('body').append(data);
        },
        error: function (xhr) {
            console.error(xhr);
        }
    });
}

$(document).ready(function () {
    initPopupCookie();
});
